<template lang="pug">
.c-dropdown.c-dropdown--right
  button.c-btn.c-emoji-picker__trigger.c-tooltip.c-tooltip--n(type='button', data-tooltip='Add emoji', data-toggle="dropdown", aria-expanded="false", :disabled="disabled")
    i.icon-smile
  .c-dropdown__menu.c-emoji-picker__content
    .c-emoji-picker__query
      input.form-ctl(type='text', autocomplete='off', placeholder='Search', v-model='search')
    .c-emoji-picker__result
      dl(v-for='c in filtered', v-show='c.emojis.length > 0')
        dt.c-emoji-picker__category(v-text='c.category')
        dd
          button.c-btn.c-emoji-picker__item(
            type='button',
            v-for='em in c.emojis',
            :title="em.name",
            @click.stop.prevent='pickEmoji(em.name)',
            :style='{ backgroundImage: "url(" + getEmojiUrl(em.image) + ")" }'
          )
</template>
<script>
//
// Emoji Picker
// tom.dropdown 依存
// ---------------------------------------------
import trim from 'latest_modules/lodash/trim';
import map from 'latest_modules/lodash/map';
import filter from 'latest_modules/lodash/filter';
import flatten from 'latest_modules/lodash/flatten';
import find from 'latest_modules/lodash/find';
import { webp } from '../../util/url';
import emojiData from '../../data/emoji';

const PATH_RESIZE =
  (window.tom &&
    window.tom.conf &&
    window.tom.conf.path &&
    window.tom.conf.path.resize) ||
  'https://resize.cdn.otakumode.com/';
const DIR_EMOJI = 'bypass/emoji/twitter/';

export default {
  props: ['inputNode', 'disabled'],

  computed: {
    isIframe() {
      return window.parent !== window.self;
    },
    filtered() {
      if (!this.shown) {
        return [];
      }
      const s = trim(this.search);
      if (s === '') {
        return emojiData;
      }
      var res = map(emojiData, function (o) {
        res = {};
        res.category = o.category;
        res.emojis = filter(o.emojis, (e) => e.name.includes(s));
        return res;
      });
      return res;
    }
  },

  mounted() {
    $(this.$el).on('shown.tom.dropdown', () => {
      return (this.shown = true);
    });
    $(this.$el).on('hidden.tom.dropdown', () => {
      return (this.shown = false);
    });
  },

  methods: {
    getEmojiByName(name) {
      const allEmojis = flatten(map(emojiData, 'emojis'));
      return find(allEmojis, { name });
    },

    pickEmoji(name) {
      const emoji = this.getEmojiByName(name);
      if (!this.inputNode) {
        return;
      }

      const val = this.inputNode.value;
      const pos = this.inputNode.selectionStart || 0;
      const before = val.substr(0, pos);
      const after = val.substr(pos, val.length);
      const colon = `:${emoji.name}:`;
      /* eslint-disable vue/no-mutating-props */
      this.inputNode.value = `${before}${colon}${after}`;
      this.inputNode.selectionStart = this.inputNode.selectionEnd =
        before.length + colon.length;
      /* eslint-enable vue/no-mutating-props */
      this.inputNode.focus();
      $.ui.dropdown._clearDropdowns();
    },

    getEmojiUrl(imageFileName) {
      const src = webp(`${PATH_RESIZE}${DIR_EMOJI}${imageFileName}`);
      return src;
    }
  },

  data() {
    return {
      shown: false,
      search: ''
    };
  },

  watch: {
    shown(isShown) {
      // iframe内のコンテンツの場合にのみ実行
      if (this.isIframe) {
        let documentHeight = 0;

        // 絵文字ピッカーの表示時
        if (isShown) {
          // 絵文字ピッカーのdrop-shadowは
          // $document.height()に含まれないので多少余裕を持たせておく
          const shadowHeight = 10;
          documentHeight = $(document).height() + shadowHeight;
        }

        // 絵文字ピッカーの表示toggleで高さが変化するので親に伝える
        window.vueEventBus &&
          window.vueEventBus.userComments &&
          window.vueEventBus.userComments.$emit(
            'CHANGE_HEIGHT',
            documentHeight
          );
      }
    }
  }
};
</script>
